module.exports = __webpack_public_path__ + "img/Icon-no-notes.50f8379a.svg";